import React, { ReactNode, useState, useEffect } from 'react';
import styled from 'styled-components';
import Scroll from 'react-scroll';
import ReactGA from 'react-ga';

import IconArrow from '../../../assets/icon/ic-right@2x.png';
import IconDownArrow from '../../../assets/icon/ic-down@2x.png';
import { media } from '../../common/Layout';

const { scroller } = Scroll;

type StyledType = {
  nodeColor?: string;
  nodeCountColor?: string;
};

const PathComponent = styled.div`
  /* Mobile Device */
  margin-top: 26px;

  ${media.desktop`
    margin-left: 25px;
    margin-top: 40px;
    margin-bottom: 24px;
  `};
`;
const PathTitleBox = styled.div`
  display: flex;

  /* Mobile Device */
  flex-direction: column;

  ${media.desktop`
    flex-direction: row;
    align-items: center;
  `};
`;
const PathTitleText = styled.div`
  font-family: 'NotoKrM';
  font-weight: 500;

  /* Mobile Device */
  font-size: 16px;

  ${media.desktop`
    font-size: 18px;
  `};
`;
const PathTitleDesc = styled.div`
  font-family: 'NotoKrR';
  font-weight: normal;
  color: #555555;

  /* Mobile Device */
  font-size: 14px;

  ${media.desktop`
    font-size: 13px;
  `};
`;

const PathNodeBox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;

  /* Mobile Device */
  flex-direction: column;

  ${media.desktop`
    flex-direction: row;
  `};
`;
const PathNode = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-radius: 30px;
  background-color: ${(props: StyledType) => props.nodeColor};
  cursor: pointer;

  /* Mobile Device */
  width: 228px;

  ${media.desktop`
    width: 200px;
  `};
`;
const PathNodeTitle = styled.div`
  font-family: 'NotoKrM';
  font-weight: 500;
  font-size: 20px;
  color: white;
  margin-right: 3px;
`;
const PathNodeCount = styled.div`
  font-family: 'NotoKrR';
  font-weight: normal;
  font-size: 14px;
  color: ${(props: StyledType) => props.nodeCountColor};
`;
const PathNodeArrow = styled.img`
  /* Mobile Device */
  margin-top: 4px;
  margin-bottom: 5px;
  width: 7px;
  height: 10px;

  ${media.desktop`
    margin-top:0px;
    margin-bottom:0px;
    width: 18.7px;
    height: 13.7px;
    margin-left: 8.7px;
    margin-right: 9.2px;
  `};
`;

const PathSubTitleBox = styled.div``;

const PathSubTitleText = styled.div`
  font-family: 'NotoKrM';
  font-weight: 500;

  /* Mobile Device */
  font-size: 15px;

  ${media.desktop`
    font-size: 18px;
    margin-bottom: 6px;
  `};
`;
const PathSubTitleDesc = styled.div`
  font-family: 'NotoKrR';
  color: #555555;
  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop`
    font-size: 14px;
  `};
`;

interface PathUIProps {
  recommend_path: string[];
  total_counts: number[];
}

const PathUI = ({ recommend_path, total_counts }: PathUIProps) => {
  const [responsiveIconArrow, setIconArrow] = useState(IconArrow);
  useEffect(() => {
    if (window.innerWidth < 1100) {
      setIconArrow(IconDownArrow);
    } else {
      setIconArrow(IconArrow);
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1100) {
        setIconArrow(IconDownArrow);
      } else {
        setIconArrow(IconArrow);
      }
    });
  }, []);
  const MoveToPath = (index: number) => {
    scroller.scrollTo(`aivoryPath${index}`, {
      duration: 1500,
      delay: 100,
      smooth: true,
      offset: -50,
    });
  };
  const MakePathList = (): ReactNode[] | null => {
    const result: ReactNode[] | null = [];
    const nodeColorArray = ['#1a0dab', '#24b1f2', '#14ccad'];
    const nodeCountColor = ['#b5b0f7', '#defffa', '#defffa'];

    recommend_path.forEach((element, index) => {
      result.push(
        <PathNode
          nodeColor={nodeColorArray[index]}
          onClick={() => {
            ReactGA.ga('send', 'event', `click_search_ai_path_ui`);
            MoveToPath(index);
          }}
        >
          <PathNodeTitle>{element}</PathNodeTitle>
          <PathNodeCount nodeCountColor={nodeCountColor[index]}>
            {total_counts[index]}
          </PathNodeCount>
        </PathNode>
      );
      if (index < recommend_path.length - 1) {
        result.push(<PathNodeArrow src={responsiveIconArrow} />);
      }
    });

    return result;
  };
  return (
    <PathComponent>
      <PathTitleBox>
        <PathTitleText>콘텐츠 추천패턴</PathTitleText>
        <PathTitleDesc>
          키워드를 클릭하면 AI추천 연관검색어가 검색됩니다
        </PathTitleDesc>
      </PathTitleBox>
      <PathNodeBox>{MakePathList()}</PathNodeBox>
      <PathSubTitleBox>
        <PathSubTitleText>추천이 어떻게 되는지 궁금해요!</PathSubTitleText>
        <PathSubTitleDesc>
          AIVORY 가 분석한 콘텐츠 소비 패턴을 통해 추천 드립니다.
          <br />
          <em>&#39;{recommend_path[0]}&#39;</em> 토픽에 대한 추천 결과 부터
          확인해보세요!
        </PathSubTitleDesc>
      </PathSubTitleBox>
    </PathComponent>
  );
};

export default PathUI;
